import { AfterContentChecked, AfterViewInit, Component, ErrorHandler, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

import { LaskuService } from '../../_angular/service/lasku/lasku.service'

import { LaskunListaustietorivi } from '@lemon/core-firebase/model/lasku'
import { KirjanpitajaService } from 'app/_angular/service/kirjanpitaja/kirjanpitaja.service'
import { firstValueFrom } from 'rxjs'

export interface LaskuHaluatkoVarmastiPeruaMaksetuksiMerkitsemisenLemonatorDialogData {
  rivi: LaskunListaustietorivi
}

@Component({
  selector: 'lasku-haluatko-varmasti-perua-maksetuksi-merkitsemisen-lemonator-dialog',
  templateUrl: './lasku.haluatko-varmasti-perua-maksetuksi-merkitsemisen-lemonator.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LaskuHaluatkoVarmastiPeruaMaksetuksiMerkitsemisenLemonatorDialog implements OnInit, AfterViewInit, AfterContentChecked {
  private _buttonPushInflight: boolean = false

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: LaskuHaluatkoVarmastiPeruaMaksetuksiMerkitsemisenLemonatorDialogData,
    private dialogRef: MatDialogRef<LaskuHaluatkoVarmastiPeruaMaksetuksiMerkitsemisenLemonatorDialog>,
    private laskuService: LaskuService,
    private errorHandler: ErrorHandler,
    private _kirjanpitajaService: KirjanpitajaService,
  ) {}

  ngAfterContentChecked() {}

  ngOnInit() {}

  ngAfterViewInit() {}

  async peru() {
    if (this._buttonPushInflight) {
      return
    }
    this._buttonPushInflight = true

    try {
      const kirjanpitaja = await firstValueFrom(this._kirjanpitajaService.kirjautuneenKayttajanKirjanpitajaObservable)
      await this.laskuService.merkitseLaskuTaysinMaksetuksi(this.data.rivi, kirjanpitaja)
      this.dialogRef.close()
    } catch (error) {
      this.errorHandler.handleError(error)
    } finally {
      this._buttonPushInflight = false
    }
  }
}
